'use strict';

Object.defineProperty(exports, '__esModule', {
	value: true
});
function TokenService($resource, AppConstants, $cookieStore) {
	'ngInject';

	return $resource(AppConstants.apiUrl + '/refresh-token', {}, {
		refresh: {
			method: 'POST',
			params: {
				token: $cookieStore.get('token')
			}
		}
	});
}

exports['default'] = TokenService;
module.exports = exports['default'];


/** WEBPACK FOOTER **
 ** ./client/components/token/token.service.js
 **/